var image_upload_default = {
  "container": "zPKo5",
  "disabled": "_7-jod",
  "imageInput": "HDTy-",
  "overlay": "F2F4f",
  "text": "_2cKEJ",
  "shown": "n4IhR",
  "hide": "bJ51p",
  "spinner": "_0iSim",
  "spin": "CBAqp"
};
export {
  image_upload_default as default
};
//# sourceMappingURL=image-upload-scss.js.map
